// @core/api/endpoints/project/remove_item_from_component.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ItemResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Remove item from component
 * Removes the component association from a project item. The item remains in the project.
 */
export async function RemoveItemFromComponent(
  project_id: string,
  component_id: string,
  item_id: string,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/components/:component_id/items/:item_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':component_id', encodeURIComponent(component_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.delete<ItemResponse>(requestPath, requestOptions);
}
